import WorkflowGroup from "../../components/WorkflowGroup/WorkflowGroup"
import { MyFilesSectionProps } from "./MyFilesSection.types"
import "./MyFilesSection.css"
import { getDate } from "../../../../utils/utils"
import WorkflowFile from "../../components/WorkflowFile/WorkflowFile"
import DownIcon from "../../../../media/DownIcon"
import AddItemAlert from "../../../../components/AddItemAlert/AddItemAlert"
import { useState } from "react"
import ConfirmationAlert from "../../../../components/ConfirmationAlert/ConfirmationAlert"
import AddToGroupAlert from "../../components/AddToGroupAlert/AddToGroupAlert"
import useMoveFile from "../../../../hooks/useMoveFile"

const MyFilesSection = (props: MyFilesSectionProps) => {

  const {
    workflows,
    selectedWorkflow,
    onSelectWorkflow,
    onOpenWorkflow,
    onDeleteWorkflow,
    onMoveWorkflow,
    showMoveWorkflow,
    onHideMoveWorkflow,

    groups,
    parentGroups,
    showAddGroup,
    newGroupInput,
    error,
    selectedGroup,
    showMoveGroup,
    onHideMoveGroup,
    onSelectGroup,
    onSelectParentGroup,
    onOpenGroup,
    onAddGroup,
    onHideAddGroup,
    onMoveGroup,
    onDeleteGroup,
    onError,
    onMoveWorkflowGroup
  } = props

  const [{
    groups: groupDestinations,
    selectedGroup: selectedGroupDestination,
    parentGroups: parentGroupDestinations,
    onLoadSubGroups: onLoadSubGroupDestinations,
    onSelectGroup: onSelectGroupDestination,
    onMoveWorkflow: onMoveWorkflowToDestination,
    onMoveGroup: onMoveGroupToDestination

  }] = useMoveFile({
    onMove: onMoveWorkflowGroup,
    workflowId: selectedWorkflow?.workflow_id,
    groupId: selectedGroup?.id,
    onError: onError
  })

  const [showDeleteGroup, setShowDeleteGroup] = useState<boolean>(false)

  return (
    <div className="myfiles-section-container">
      <div className="breadcrumb-container">
        {parentGroups.length > 0 && (
          <div className="group-back-button" onClick={() => onSelectParentGroup(parentGroups.length-1)}>
            <DownIcon />
          </div>
        )}
        {parentGroups.map((group, key) => (
          <>
            <p key={group.id} onClick={() => onSelectParentGroup(key)}>{group.name}</p>
            {key < parentGroups.length-1 && (
              <p>/</p>
            )}
          </>
        ))}
      </div>
      {groups.length > 0 && (
        <div className="myfiles-header-container">
          <p className="workflows-result-header">SUBFOLDER NAME</p>
          <p className="workflows-result-header">DATE</p>
          <p className="workflows-result-header"></p>
        </div>
      )}

      {groups.map((group, i) => (
        <WorkflowGroup 
          key={group.id}
          isSelected={selectedGroup?.id === group.id}
          onSelect={() => onSelectGroup(group)}
          onClick={() => onOpenGroup(group)}
          name={group.name}
          date={getDate(group.date)}
          ellipsisMenu={[
            {
              item: "Open",
              onClick: () => onOpenGroup(group)
            },
            {
              item: "Move",
              onClick: () => onMoveGroup(group)
            },
            {
              item: "Delete",
              onClick: () => setShowDeleteGroup(true)
            }
          ]}
        />
      ))}

      {groups.length > 0 && (
        <br />
      )}

      {workflows.length > 0 && (
        <div className="all-workflows-header-container">
          <p className="workflows-result-header">WORKFLOW NAME</p>
          <p className="workflows-result-header">ASSET ID</p>
          <p className="workflows-result-header">DATE</p>
          <p className="workflows-result-header">WORKFLOW TYPE</p>
          <p className="workflows-result-header"></p>
        </div>
      )}
      {workflows.map((workflow, i) => (
        <WorkflowFile
          key={workflow.workflow_id}
          isSelected={selectedWorkflow?.workflow_id === workflow.workflow_id}
          onSelect={() => onSelectWorkflow(workflow)}
          onClick={() => onOpenWorkflow(workflow)}
          assetId={workflow.asset_id}
          workflowType={workflow.workflow_type}
          date={getDate(workflow.created_at)}
          enabled={workflow.is_fully_uploaded}
          filename={workflow.filename === "" ? workflow.asset_id : workflow.filename}
          ellipsisMenu={[
            {
              item: "Open",
              onClick: () => onOpenWorkflow(workflow)
            },
            {
              item: "Move",
              onClick: () => onMoveWorkflow(workflow)
            },
            {
              item: "Remove",
              onClick: () => onDeleteWorkflow(workflow)
            }
          ]}
        />       
      ))}

      {workflows.length === 0 && groups.length === 0 && error === undefined && (
        <div className="no-results-container">
          <p>No existing groups or workflows.</p>
        </div>
      )}

      {workflows.length === 0 && groups.length === 0 && error !== undefined && (
        <div className="no-results-container">
          <p>{`Failed to fetch groups or workflows: ${error.message}`}</p>
        </div>
      )}

      <AddItemAlert
        title="Add Group" 
        show={showAddGroup}
        input={newGroupInput}
        onSubmit={onAddGroup}
        onHide={onHideAddGroup} 
      />

      <ConfirmationAlert
        show={showDeleteGroup}
        title="Delete Group"
        subtitle="Are you sure you want to delete this group. This action cannot be undone. Workflows in this group will not be deleted."
        onConfirmText="Delete"
        onConfirm={onDeleteGroup}
        onCancel={() => setShowDeleteGroup(false)}
      />

      <AddToGroupAlert 
        show={showMoveWorkflow}
        parentGroups={parentGroupDestinations}
        onHide={onHideMoveWorkflow} 
        onMove={() => onMoveWorkflowToDestination(parentGroups.length > 0 ? parentGroups[parentGroups.length-1].id : undefined)}
        groups={groupDestinations}
        selectedGroup={selectedGroupDestination}
        onSelectGroup={onSelectGroupDestination}
        onLoadGroups={onLoadSubGroupDestinations}
      />

      <AddToGroupAlert 
        show={showMoveGroup}
        parentGroups={parentGroupDestinations}
        onHide={onHideMoveGroup} 
        onMove={onMoveGroupToDestination}
        groups={groupDestinations}
        selectedGroup={selectedGroupDestination}
        onSelectGroup={onSelectGroupDestination}
        onLoadGroups={onLoadSubGroupDestinations}
      />
    </div>
  )
}

export default MyFilesSection